import * as React from "react";
import "./WarningDisplay.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
export function WarningDisplay({ children, linkText, caption, onLinkClicked, onCloseClicked }) {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "warning-display" },
        React.createElement("div", { className: "warning-display-caption" },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "exclamation-triangle"] }),
            React.createElement("b", null, caption !== null && caption !== void 0 ? caption : t("common:warning-display-default-caption", "Warning")),
            React.createElement("div", { style: { flexGrow: "1" } }),
            onCloseClicked && (React.createElement("button", { className: "icon-button-small", onClick: onCloseClicked },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "times"] })))),
        children,
        linkText && onLinkClicked && React.createElement("a", { onClick: onLinkClicked }, linkText)));
}
